import React, { useState } from 'react';
import { Modal, Button, Form, Table } from 'react-bootstrap';
import PageHeader from '../components/PageHeader';
import { ToastContainer, toast } from 'react-toastify';
import { FaDownload } from "react-icons/fa";


const Import = ({ show, handleClose, refreshData , modalTitle, pageHeaderTitle, statusOptions = [] , service , sampleFileUrl,sampleFileName ,columns , instructions}) => {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleFileUpload = async () => {
    if (!selectedFile) {
      toast.warning('Please select a file first.');
      return;
    }
    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('fileName', selectedFile.name);

    try {
      const response = await service.uploadFile(formData);
      if (response.status === 201) {
        toast.success(response.data.message || 'File uploaded successfully!');
        refreshData();
        handleClose();
      } else {
        toast.error(response?.data?.message || 'File upload failed!');
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      toast.error(error?.response?.data?.message || error.message  || 'Error uploading file');
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <div className="card bg-light p-3 border-info lh-1">
            {instructions.map((instruction, index) => (
                <p key={index}>{instruction}</p>
              ))}
            </div>

            <div className="row justify-content-center">
              <div className="col-12">
                <PageHeader
                  title={pageHeaderTitle}
                  button_label={
                    <>
                      <FaDownload style={{ marginRight: "5px" }} />
                      Download Sample
                    </>
                  }
                  href= {sampleFileUrl}
                  className="btn btn-sm btn-success"
                  download={sampleFileName}
                  
                />
              </div>
              <div className="table-responsive">
                <Table bordered responsive>
                  <thead>
                    <tr>
                      {columns.slice(1).map((column, index) => (
                        <th key={index}>{column.Header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {columns.slice(1).map((column, index) => (
                        <td key={index}>{column.sample}</td>
                      ))}
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
            <Form.Group className="mb-4 mt-5">
              <Form.Label>Choose Xlsx File</Form.Label>
              <Form.Control type="file" accept="..xlsx,.xls,.csv" onChange={handleFileChange} />
            </Form.Group>

            {/* <Form.Group className="mb-4">
              <Form.Label>Status</Form.Label>
              <Form.Control as="select" value={status} onChange={handleStatusChange}>
                {statusOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Source</Form.Label>
              <Form.Control type="text" value={source} onChange={handleSourceChange} />
            </Form.Group> */}

            <div className="modal-footer">
              <Button variant="danger" size="sm" onClick={handleClose} className="me-2">Cancel</Button> 
              <Button variant="primary" size="sm" onClick={handleFileUpload}>Import</Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ToastContainer containerId="toast-container" position="bottom-right" />
    </>
  );
};

export default Import;
